import type { sendParameters } from "$lib/interfaces/send-params.interface";

export async function send({ method, path, data }: sendParameters): Promise<any> {
  const opts: RequestInit = { method, headers: {}, credentials: "include" };

  if (data) {
    opts.headers = { "Content-Type": "application/json" };
    opts.body = JSON.stringify(data);
  }

  const apiUrl = import.meta.env.VITE_API_PATH || "/api";
  const response = await fetch(`${apiUrl}/${path}`, opts);

  const contentTypeHeader = response.headers.get("Content-Type");
  return contentTypeHeader?.includes("application/json") ? response.json() : response;
}

export function GET(path: string): Promise<any> {
  return send({ method: "GET", path });
}

export function DEL(path: string): Promise<any> {
  return send({ method: "DELETE", path });
}

export function POST(path: string, data: any): Promise<any> {
  return send({ method: "POST", path, data });
}

export function PUT(path: string, data: any): Promise<any> {
  return send({ method: "PUT", path, data });
}

export function PATCH(path: string, data: any): Promise<any> {
  return send({ method: "PATCH", path, data });
}
